import photo_1 from "./WhiteHousePictures/Photo-1.webp";
import photo_2 from "./WhiteHousePictures/Photo-2.webp";
import photo_3 from "./WhiteHousePictures/Photo-3.webp";
import photo_4 from "./WhiteHousePictures/Photo-4.webp";

export const ActivistPhotoContent = [
  {
    id: 1,
    title: "Photos",
    latestPicture: {
      image: photo_1,
      date: "22 Dec 2021",
      time: "2:46 PM",
      location: "",
    },
    pictures: [
      {
        image: photo_1,
        date: "22 Dec 2021",
        time: "2:46 PM",
        location: "",
      },
      {
        image: photo_2,
        date: "14 April 2022",
        time: "11:58 AM",
        location: "",
      },
      {
        image: photo_3,
        date: "20 Aug 2022",
        time: "2:44 PM",
        location: "",
      },
      {
        image: photo_4,
        date: "4 Nov 2022",
        time: "9:53 PM",
        location: "",
      },
    ],
  },
];
